<template>
    <lazyMetaChart
    v-if=" $route.query.authCode ==='rising_admin' "
    :ticker="$route.query.ticker"
    :num="$route.query.num"
    :datetime="$route.query.datetime"
    :signal="$route.query.signal"
    :isPopupOpen="false"
    />
    <div v-else>
        <p :style="{color:'red', fontSize:'30px', textAlign:'center'}"> Access denined </p>
    </div>
</template>

<script setup>
import { defineAsyncComponent } from "vue";
import { useRoute } from "vue-router";
const lazyMetaChart = defineAsyncComponent(() =>
  import("@/components/chart/meta-chart/CaptureMetaChart.vue")
);
const route = useRoute();

</script>

<style lang="scss" scoped>

</style>